module.exports = __webpack_public_path__ + "static/img/Logo.fc7c58d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doorder/Logo.png
// module id = wuts
// module chunks = 0